// Hosts on a shared domain that are standalone sites, not children of the parent domain's site.
// Must be kept in sync with STANDALONE_SUBDOMAIN_SITES in server/lib/config/constants.js
export const STANDALONE_SUBDOMAIN_SITES = ['dinside.dagbladet.no', 'borsen.dagbladet.no'];

export const isStandaloneSubdomainSite = site => STANDALONE_SUBDOMAIN_SITES.includes(String(site?.gamSiteId || '').toLowerCase());

/**
 * Predicate factory: is `site` the parent (by domain) of the site with `currentGamSiteId`?
 * Standalone sub-domain sites have no parent, so nothing is inherited from the domain's site.
 */
export const isParentSiteOf = currentGamSiteId => site =>
    !isStandaloneSubdomainSite({ gamSiteId: currentGamSiteId })
    && site?.gamSiteId !== currentGamSiteId
    && !!currentGamSiteId?.endsWith(site.gamSiteId);
